var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightWeather(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 45,
    viewBox: "0 0 24 19.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffaa45;}.b{fill:#ffda69;}.c{fill:#868686;}.d{fill:#e6e6e6;}.e{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.513 -20.252)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.381,23.293a.616.616,0,0,1-.569-.38L24.063,21.1a.616.616,0,1,1,1.138-.471l.749,1.809a.616.616,0,0,1-.569.851Z",
    transform: "translate(-2.883 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.13,39.125a.616.616,0,0,1-.236-1.185l1.809-.749a.616.616,0,0,1,.472,1.138l-1.809.749a.613.613,0,0,1-.236.047Z",
    transform: "translate(0 -6.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.8,29.74a.616.616,0,0,1-.236-1.185l1.809-.749a.616.616,0,0,1,.472,1.138l-1.809.749A.613.613,0,0,1,39.8,29.74Z",
    transform: "translate(-8.711 -2.888)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.023,23.293a.616.616,0,0,1-.569-.852l.749-1.809a.616.616,0,1,1,1.138.471l-.749,1.809A.616.616,0,0,1,34.023,23.293Z",
    transform: "translate(-6.491)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.632,45.966a.616.616,0,0,1-.569-.852l.749-1.809a.616.616,0,1,1,1.138.472L25.2,45.586A.616.616,0,0,1,24.632,45.966Z",
    transform: "translate(-2.883 -8.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.938,29.735a.613.613,0,0,1-.236-.047l-1.809-.749a.616.616,0,0,1,.472-1.138l1.809.749a.616.616,0,0,1-.236,1.185Z",
    transform: "translate(0 -2.882)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.106,
    cy: 5.106,
    r: 5.106,
    transform: "translate(19.909 23.648)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.9,27.765a3.88,3.88,0,1,1-1.48.3,3.865,3.865,0,0,1,1.48-.3",
    transform: "translate(-2.887 -2.887)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M38.556,32.414A5.55,5.55,0,0,0,33.6,35.493a4.262,4.262,0,0,0-.664,8.475,28.045,28.045,0,0,0,4.906.352,25.36,25.36,0,0,0,4.7-.271,3.138,3.138,0,0,0,2.9-3.267,3.323,3.323,0,0,0-1.337-2.66c0-.055,0-.11,0-.165A5.549,5.549,0,0,0,38.556,32.414Z",
    transform: "translate(-4.92 -4.673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M43.552,39.571a4.309,4.309,0,0,0-8.384-1.97,3.046,3.046,0,0,0-.769-.108,3.079,3.079,0,0,0-3.079,3.079,3.113,3.113,0,0,0,2.6,2.951,26.793,26.793,0,0,0,4.691.333,23.956,23.956,0,0,0,4.479-.251c1.28-.232,1.884-.895,1.884-2.056A2.094,2.094,0,0,0,43.552,39.571Z",
    transform: "translate(-5.689 -5.441)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M34.4,38.777a3.071,3.071,0,0,1,.769.108,4.305,4.305,0,0,1,8.416.48A4.306,4.306,0,0,0,35.167,37.6a3.046,3.046,0,0,0-.769-.108,3.079,3.079,0,0,0-3.079,3.079,2.824,2.824,0,0,0,.073.632A3.078,3.078,0,0,1,34.4,38.777Z",
    transform: "translate(-5.689 -5.441)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightWeather);
export default __webpack_public_path__ + "static/media/light-weather.4cbab2d4116a56d2d9e1e0d902f92dc7.svg";
export { ForwardRef as ReactComponent };